import axios from 'axios';
import { GetWLData } from "../../wl";
import nextSession from 'next-session';
import { SetLog, TagLogs } from '../../logs/set-log';

export async function SendSharp(
  params = false, // -> required -> {}
) {
  let result;
  const userEmail = params.userEmail;
  let body = params.body;
  const req = params.req || {};
  const res = params.res || {};

  if (!userEmail) {
    SetLog(
      TagLogs.error_sharpspring,
      { params, details: 'params.userEmail undefined' },
      false
    );
    return false;
  }

  if (!body) {
    SetLog(
      TagLogs.error_sharpspring,
      { params, details: 'params.body undefined' },
      false
    );
    return false;
  }

  const sharp = await GetWLData({
    keyName: `config_campos_sharpspring`,
  });

  const arraySharpKeys = sharp.data.config_campos_sharpspring;

  body = Object.fromEntries(
    Object.entries(body).filter(([key, value]) => key !== '')
  );

  // separando valores aceitos e configurados na sharp
  const acceptKeys = Object.keys(arraySharpKeys);
  var bodyKeys = Object.keys(body);

  // filtrando valores recebidos no body pelos aceitos na sharp
  var acceptedKeys = bodyKeys.filter((item) => acceptKeys.includes(item));

  // configurando apenas valores aceitos em "data", para enviar para sharp
  var lead = {};
  acceptedKeys.forEach((item) => {
    lead[arraySharpKeys[item]] = body[item];
  });

  // Bloquear envio de dados para sharpspring em developer emails
  if (
    process.env.BLOCK_SHARP_WITH_BLACK_LIST_EMAILS == 1 &&
    process.env.BLACK_LIST_EMAILS.split(',').includes(userEmail)
  ) {
    return {
      status: true,
      message: 'developer_runnig',
      lead,
    };
  }
  var sharpUri = `${process.env.SECRET_SHARPSPRING_API_URI}`;
  sharpUri += `?accountID=${process.env.SECRET_SHARPSPRING_API_ACCOUNT_ID}`;
  sharpUri += `&secretKey=${process.env.SECRET_SHARPSPRING_API_SECRET_KEY}`;
  const getSession = nextSession();
  const session = await getSession(req, res);

  // recuperando lead pelo email
  const beforeLead = await axios
    .post(sharpUri, {
      method: 'getLeads',
      params: {
        where: {
          emailAddress: [userEmail],
        },
        limit: 1,
        offset: 0,
      },
      id: session.id,
    })
    .then((data) => {
      return data.data?.result?.lead;
    });

  var method;

  // // atribuindo proprietário do lead
  // if(process.env.SECRET_SHARPSPRING_OWNERID) {
  // 	lead.ownerID = process.env.SECRET_SHARPSPRING_OWNERID
  // }

  if ((beforeLead?.length ?? 0) > 0) {
    // Update Lead
    method = 'updateLeads';
    lead.id = beforeLead[0].id;
  } else {
    // Create Lead
    method = 'createLeads';
    lead.emailAddress = userEmail;
  }

  // clique_cta_usina_listing
  // clique_cta1_card_usina
  // clique_cta2_card_usina

  lead = configureCheckedInputsInLead(
    lead,
    beforeLead,
    arraySharpKeys.clique_cta_usina_listing
  );

  lead = configureCheckedInputsInLead(
    lead,
    beforeLead,
    arraySharpKeys.clique_cta1_card_usina
  );

  lead = configureCheckedInputsInLead(
    lead,
    beforeLead,
    arraySharpKeys.clique_cta2_card_usina
  );

  result = await axios
    .post(sharpUri, {
      method,
      params: { objects: [lead] },
      id: session.id,
    })
    .then((data) => {
      // console.log({data: data.data})
      return true;
    })
    .catch((err) => {
      console.log({ errorSharp: err.message });
      return false;
    });


  return result;
}

/**
 * Configura o lead na sharp para campos Check, sem gravar dados repetidos
 * @returns lead
 */
const configureCheckedInputsInLead = (lead, beforeLead, key) => {
  // Verifica se o valor está setado
  if (lead?.[key]) {
    // Garante que o card não seja inserido mais de uma vez
    if (!beforeLead?.[0]?.[key]?.includes(lead[key])) {
      // Adiciona o item na lista: caso seja o primeiro item, iniciará com ", " -- (sendo removido no próximo item)
      const sharpUsinaListClicked = `${beforeLead?.[0]?.[key]}, ${lead[key]}`;

      // Caso seja o primeiro item, precisa ser atribuído o valor direto, para não ficar iniciando com ", "
      if (!sharpUsinaListClicked.startsWith(', ')) {
        lead[key] = sharpUsinaListClicked;
      }
    } else {
      delete lead[key];
    }
  }

  return lead;
};
